import { DeleteDocuments } from '../components/DeleteDocuments';
import { useSettingsContext } from '../context/SettingsContext';

export const DeleteDocsRoute = () => {
  const { caseId, isReprocessing } = useSettingsContext();

  return <DeleteDocuments caseId={caseId} isReprocessing={isReprocessing} />;
};
